module.exports = __webpack_public_path__ + "img/6.dcd9b2c0.jpg";